/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useRef, useState } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { API_URL, PaperComponent } from "../../utils/constants";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import useAuth from "hooks/useAuth";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "./formGioithieu.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CancelIcon from "@mui/icons-material/Cancel";
const defaultValue = {
  tieude: "",
  noidung: "",
  tacgia: null,
  slug: "",
  trangthai: "draft",
  anhdaidien: null,
};

const FormGioiThieu = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
}) => {
  const { accessToken, user } = useAuth();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const toolBarRef = useRef(null);
  const formRef = useRef(null);
  const inputFileRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const setAlert = useSetRecoilState(AlertState);

  useEffect(() => {
    if (data && data.id) {
      setDataState(data);
    } else {
      defaultValue.tacgia = user?.username;
      setDataState(defaultValue);
    }
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    if (action == "Edit") {
      _data["id"] = data?.id;
      _data["rowIndex"] = data?.rowIndex;
    } else {
      _data["ngaytao"] = new Date().toISOString();
      _data["ngayxuatban"] = new Date().toISOString();
    }
    _data["ngaycapnhat"] = new Date().toISOString();
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };
  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
    }
  }, [open]);

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeEditor = (event, editor) => {
    const data = editor.getData();
    setDataState((prev) => ({
      ...prev,
      noidung: data,
    }));
  };
  const handleChangeInput = (key) => (e) => {
    const { value } = e.target;
    setDataState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const stringToSlug = (str) => {
    str = str.toLowerCase();
    const map = {
      đ: "d",
    };
    str = str.replace(/[đ]/g, function (matched) {
      return map[matched];
    });
    str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    str = str.replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-");
    return str;
  };
  const handleToAutoSlug = () => {
    const value = stringToSlug(dataState?.tieude);
    setDataState((prev) => ({
      ...prev,
      slug: value,
    }));
  };
  const handleClearSlug = () => {
    setDataState((prev) => ({
      ...prev,
      slug: "",
    }));
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "50rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <form
        ref={formRef}
        method="post"
        encType="multipart/form-data"
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          {title ? title : "Chỉnh sửa Giới thiệu"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "1rem" }}>
          <Box>
            {/* show lỗi từ khi không xác định được từ các field ở form */}
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tiêu đề <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  name="tieude"
                  error={errors ? !!errors.tieude : false}
                  helperText={errors?.tieude}
                  value={dataState?.tieude ? dataState?.tieude : ""}
                  onChange={handleChangeInput("tieude")}
                  placeholder="Nhập tiêu đề"
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      tieude: "",
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Slug <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  name="slug"
                  placeholder="Nhập slug"
                  error={errors ? !!errors.slug : false}
                  helperText={errors?.slug}
                  value={dataState?.slug ? dataState?.slug : ""}
                  onChange={handleChangeInput("slug")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {dataState?.slug ? (
                          <IconButton onClick={handleClearSlug} size="small">
                            <CancelIcon />
                          </IconButton>
                        ) : (
                          <></>
                        )}
                        <IconButton
                          color="primary"
                          title="auto"
                          onClick={handleToAutoSlug}
                        >
                          <AutoAwesomeIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      slug: "",
                    });
                  }}
                />
              </Grid>
            </Grid>
            <Box marginTop={"1rem"}>
              <Typography
                fontSize={"0.75rem"}
                color={"#000000"}
                fontWeight={500}
              >
                Nội dung<span style={{ color: "red" }}>*</span>
              </Typography>
              <div ref={toolBarRef} />
              <CKEditor
                editor={DecoupledEditor}
                data={dataState && dataState.noidung ? dataState.noidung : ""}
                onReady={(editor) => {
                  if (toolBarRef.current) {
                    toolBarRef.current.appendChild(
                      editor.ui.view.toolbar.element
                    );
                  }
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "300px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
                onChange={handleChangeEditor}
                config={{
                  simpleUpload: {
                    uploadUrl: API_URL + "/media",
                    headers: {
                      "X-CSRF-TOKEN": "CSRF-Token",
                      Authorization: `Bearer ${accessToken}`,
                    },
                  },
                }}
                style={{
                  minHeight: "300px",
                  border: "1px solid #ccc",
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
function validateOBJ(tt) {
  let result = {
    tieude: !validateRequired(tt.tieude) ? "Tiêu đề không được trống" : "",
    slug: !validateRequired(tt.slug) ? "Slug không được trống" : "",
    noidung: !validateRequired(tt.noidung) ? "Nội dung không được trống" : "",
  };
  return result;
}
export default FormGioiThieu;
